module.exports = require('events').EventEmitter;



//////////////////
// WEBPACK FOOTER
// ./node_modules/stream-http/node_modules/readable-stream/lib/internal/streams/stream-browser.js
// module id = 607
// module chunks = 0